import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import PropTypes from "prop-types";
import { getPageShellDataSafely } from "@/services/contenful/getPageShellDataSafe";
import ShowAllProducts from "@/components/ShowAllProducts";
import Head from "next/head";
import { executeMasterPLP } from "@/services/server/masterplp.server";
const Loader = dynamic(() => import("@/components/loader"));

const LandingPage = ({
  locale = "en",
  params = {},
  compareMappingsData = {},
  masterPlpData = {},
}) => {
  const router = useRouter();
  const slugKey = Array.isArray(params?.slug)
    ? params.slug.join("/")
    : params?.slug || "";

  if (router.isFallback) {
    return <Loader loading={router.isFallback} />;
  }

  const pageTitle = `${slugKey.charAt(0).toUpperCase() + slugKey.slice(1)} | Kohler`;

  return (
    <>
      <Head>
        <title>{`${pageTitle}`}</title>
      </Head>

      <ShowAllProducts
        params={params}
        locale={locale}
        key={`${locale}-${slugKey}`}
        compareMappingsData={compareMappingsData}
        masterPlpData={masterPlpData}
      />
    </>
  );
};

export async function getServerSideProps({ req, params, preview, locale }) {
  const { slug = "/" } = params;
  const {
    items,
    headerNavigationData,
    footerNavigationData,
    promoBannerData,
    worldwideMenuData,
    compareMappingsData,
    apacConfigurationsData,
    translations,
  } = await getPageShellDataSafely({
    slug: `/browse/${slug}`,
    preview,
    contentType: "brazilLandingPage",
    fetchEntryBySlugFlag: true,
    locale,
  });

  const masterPlpData = await executeMasterPLP(locale, params);

  return {
    props: {
      headerNavigationData,
      footerNavigationData,
      promoBannerData,
      world: worldwideMenuData,
      apacConfigurationsData,
      translations,
      compareMappingsData,
      locale,
      params,
      masterPlpData,
    },
  };
}

LandingPage.propTypes = {
  pageData: PropTypes.object,
  locale: PropTypes.string,
  plpData: PropTypes.object,
  facetLabelsState: PropTypes.object,
  categoryConfig: PropTypes.string,
  params: PropTypes.object,
  compareMappingsData: PropTypes.object,
};

export default LandingPage;
